<app-admin-page-section titleT="admin.reports.charging-report">
    <div class="admin-action-item-list">
        <app-admin-action-item titleT="admin.reports.charging-report">
            <form [formGroup]="chargingReportForm" (ngSubmit)="downloadChargingReport()" class="charging-form grid-full-width">
                <div>
                    <h3 *ngIf="0">{{ 'admin.reports.charging-report' | translate }}</h3>

                    <mat-form-field subscriptSizing="dynamic">
                        <mat-label>{{ 'admin.reports.period' | translate }}</mat-label>
                        <mat-date-range-input [formGroup]="chargingReportForm" [rangePicker]="picker">
                            <input matStartDate formControlName="periodStartDate"
                                placeholder="{{ 'admin.reports.period-start-date' | translate }}" />
                            <input matEndDate formControlName="periodEndDate"
                                placeholder="{{ 'admin.reports.period-end-date' | translate }}" />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                        <mat-error *ngIf="
              chargingReportForm.get('periodStartDate')?.hasError('matDatepickerParse') ||
              chargingReportForm.get('periodStartDate')?.hasError('matStartDateInvalid') ||
              chargingReportForm.get('periodEndDate')?.hasError('matDatepickerParse') ||
              chargingReportForm.get('periodEndDate')?.hasError('matEndDateInvalid')
            ">
                            {{ 'admin.reports.date-invalid' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
              chargingReportForm.get('periodStartDate')?.hasError('required') ||
              chargingReportForm.get('periodEndDate')?.hasError('required')
            ">
                            {{ 'admin.reports.date-required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <button class="pull-right-on-desktop" mat-icon-button color="primary" type="submit"
                    [attr.aria-label]="'admin.reports.download' | translate"
                    [matTooltip]="'admin.reports.download' | translate"
                    [appLoadingButton]="chargingReportPending.isPending()">
                    <mat-icon svgIcon="download" />
                </button>
            </form>
        </app-admin-action-item>

        <!-- File process report -->
        <app-admin-action-item titleT="admin.reports.file-process-report">
            <app-button-indicator-download [isPending]="fileProcessReportPending.isPending()"
                (clicked)="downloadFileProcessReport()" />
        </app-admin-action-item>
    </div>
</app-admin-page-section>